module.exports = __webpack_public_path__ + "media/categories/1085-6f3ea799.svg";